import { Pipe, PipeTransform } from '@angular/core';
import { ADMISSION_REQUEST_TYPE } from 'src/app/core/constants/admission-request-type.enum';
import { TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'getAdmissionServiceName'
})
export class GetAdmissionServiceNamePipe implements PipeTransform {
    public constructor(private translateService: TranslateService) {}
    public transform(requestType: string): string {
        if (requestType) {
            return this.translateService.instant(ADMISSION_REQUEST_TYPE[requestType]);
        }
        return 'N/A';
    }
}
